__turbopack_context__.v({
  "benefitsTitle": "largeStyles-module-scss-module__j2GAbq__benefitsTitle",
  "button": "largeStyles-module-scss-module__j2GAbq__button",
  "coins": "largeStyles-module-scss-module__j2GAbq__coins",
  "coinsCol": "largeStyles-module-scss-module__j2GAbq__coinsCol",
  "currencyIcon": "largeStyles-module-scss-module__j2GAbq__currencyIcon",
  "disabledText": "largeStyles-module-scss-module__j2GAbq__disabledText",
  "freeSpins": "largeStyles-module-scss-module__j2GAbq__freeSpins",
  "goldenKey": "largeStyles-module-scss-module__j2GAbq__goldenKey",
  "icon": "largeStyles-module-scss-module__j2GAbq__icon",
  "newCount": "largeStyles-module-scss-module__j2GAbq__newCount",
  "oldCount": "largeStyles-module-scss-module__j2GAbq__oldCount",
  "root": "largeStyles-module-scss-module__j2GAbq__root",
  "sweepstakeBonus": "largeStyles-module-scss-module__j2GAbq__sweepstakeBonus",
  "vipCoin": "largeStyles-module-scss-module__j2GAbq__vipCoin",
  "vipPointsValue": "largeStyles-module-scss-module__j2GAbq__vipPointsValue",
  "wrapper": "largeStyles-module-scss-module__j2GAbq__wrapper",
});
